import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class SpaceReportPinModel extends ModeModelBase {
  override _name = 'spaceReportPin';
  override idAttribute = 'token';
  override belongsTo = 'space';
  override parentIdAttribute = 'token';

  override attributes = [{ name: 'space_token' }, { name: 'report_token' }, { name: 'report_id' }];
}

@Injectable({ providedIn: 'root' })
export class SpaceReportPinModelAccessor extends ModelAccessorBase<SpaceReportPinModel> {
  override name = 'spaceReportPin';
  override idAttribute = 'token';
  override parentModel = 'space';
  override parentIdAttribute = 'token';
  override createAttributes = ['space'];

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.spaceReportPin');
  }

  createModel(resource, opts?) {
    const model = new SpaceReportPinModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
